import type {Document} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name similarDocumentsDataService
 * @module portaro.components.kp-similar-documents
 *
 *
 * @description
 * Data service for providing similar documents
 */
export class SimilarDocumentsDataService {
    public static serviceName = 'similarDocumentsDataService';

    private static readonly RECORDS_ROUTE = 'records';
    private static readonly SIMILAR_DOCUMENT_ROUTE = 'similar';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async query(recordId: string): Promise<Document[]> {
        return this.ajaxService
            .createRequest(`${SimilarDocumentsDataService.RECORDS_ROUTE}/${recordId}/${SimilarDocumentsDataService.SIMILAR_DOCUMENT_ROUTE}`)
            .get();
    }
}
